module.exports = __webpack_public_path__ + "shield.svg?ce08794618aca13ef6362e8708ac4bf1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/shield.svg
// module id = 1279
// module chunks = 2